<template>
    <component :is="appName"></component>
</template>

<script>
import NewsroomCh_News from "./components/NewsroomCh_News.vue";
import NewsroomCh_Events from "./components/NewsroomCh_Events.vue";
import NewsroomCh_Galleries from "./components/NewsroomCh_Galleries.vue";
import NewsroomCh_Video from "./components/NewsroomCh_Video.vue";
import NewsroomCh_SocialMedia from "./components/NewsroomCh_SocialMedia.vue";

export default {
    name: 'newsroom-ch',
    data() {
        return {
            appName: this.rootData.newsroomEditTyp
        }
    },
    components: {
        NewsroomCh_News,        
        NewsroomCh_Events,
        NewsroomCh_Galleries,
        NewsroomCh_Video,
        NewsroomCh_SocialMedia
    },    
}


</script>